// @mui
import { Container, Grid } from '@mui/material';

import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores/store';

//Localization
import useLocales from 'src/hooks/useLocales';
import Page from 'src/components/Page';
import useSettings from 'src/hooks/useSettings';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import { PATH_DASHBOARD } from 'src/routes/paths';
import ShopDetailTableRow from './ShopDetailTableRow';
import { useState, useEffect } from 'react';
import Loader from 'src/components/loader/Loader';
// ----------------------------------------------------------------------

export default observer(function ShopDetailHeader() {
  const { translate } = useLocales();

  const { ShopStore, ContractInfoStore, RentPaymentStore, ElectricityPaymentStore } = useStore();
  const { selectedShopDetail, clearSelectedShop, ID, loadShopDetail } = ShopStore;
  const { GetHistory, ContractHistoryResult } = ContractInfoStore;
  const { GetRentPaymentHistory, RentPaymentHistoryResult } = RentPaymentStore;
  const { GetElectricityPaymentHistory, ElectricityPaymentHistoryResult } = ElectricityPaymentStore;

  const [isLoading, setIsLoading] = useState(true); // Track loading state

  useEffect(() => {
    if (ID) {
      setIsLoading(true);
      loadShopDetail(ID)
        .then(() => {
          GetElectricityPaymentHistory({ shopId: ID });
          GetRentPaymentHistory({ shopId: ID });
          GetHistory({ shopId: ID });
        })
        .finally(() => setIsLoading(false)); // Ensure loading ends
    }
  }, [loadShopDetail, ID]);

  const { themeStretch } = useSettings();

  // Handle case when no ID or data is available
  if (!ID) {
    return (
      <Page title={translate('Shop.ShopDetails')}>
        <Container maxWidth={themeStretch ? false : 'lg'}>
          <HeaderBreadcrumbs
            heading={translate('Shop.ShopDetails')}
            links={[
              { name: `${translate('Department.Dashboard')}`, href: PATH_DASHBOARD.root },
              { name: `${translate('Shop.Shop')}`, href: PATH_DASHBOARD.Shop.list },
            ]}
          />
          <p>{translate('Shop.NoData')}</p>
        </Container>
      </Page>
    );
  }

  return (
    <Page title={translate('Shop.ShopDetails')}>
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={translate('Shop.ShopDetails')}
          links={[
            { name: `${translate('Department.Dashboard')}`, href: PATH_DASHBOARD.root },
            { name: `${translate('Shop.ShopDetails')}`, href: PATH_DASHBOARD.Shop.list },
          ]}
        />
        {isLoading ? ( // Show loading state
          <Grid container justifyContent="center" alignItems="center" style={{ height: '50vh' }}>
            <Loader /> {/* Replace with Loader */}
          </Grid>
        ) : selectedShopDetail ? ( // Render details if available
          <Grid container>
            <ShopDetailTableRow
              row={selectedShopDetail}
              electricityRow={ElectricityPaymentHistoryResult}
              rentRow={RentPaymentHistoryResult}
              contractRow={ContractHistoryResult}
              clearShop={clearSelectedShop}
            />
          </Grid>
        ) : (
          <Grid container justifyContent="center" alignItems="center" style={{ height: '50vh' }}>
            <p>{translate('Shop.NoData')}</p>
          </Grid>
        )}
      </Container>
    </Page>
  );
});
